/**
 * @description 本地存储key前缀
 * @type {string}
 */
export const APP_STORE_KEY_PREFIX = "edu-ceragemhnb";

/**
 * @description 本地存储token key
 * @type {string}
 */
export const APP_STORE_KEY_TOKEN = "tokenKey";

/**
 * @description 本地存储用户信息 key
 * @type {string}
 */
export const APP_STORE_KEY_USER = "userKey";

/**
 * @description 加密密钥
 * @type {string}
 */
export const CRYPTO_KEY = "d~!@#$%^&*()_+++QWERTYUSD184643613osdfghj/.,m";

/**
 * @description 用户头像大小
 * @type {string}
 */
export const APP_USER_HEDA_SIZE = "30px";
/**
 * @description 菜单栏的高度
 * @type {string}
 */
export const APP_NAV_HEIGHT = "66px";
/**
 * @description 菜单栏单个元素宽度
 * @type {string}
 */
export const APP_MENU_ITEM_WIDTH = "8.5em";

/**
 * @description 菜单栏单个元素的高度
 * @type {number}
 */
export const APP_MENU_ITEM_HEIGHT = 45;

export const APP_MENUS_PREFIX = [
    {title: "首页", path: "/"},
]

/**
 * @description 商学院介绍的固定路由
 * @type {[{children: *[], title: string}]}
 */
export const APP_MENUS_PRESENT = [
    {
        title: "商学院介绍",
        path:"/college-introductions",
        children: []
    },
]

export const APP_MENUS_SUFFIX = {
    title: "关于我们",
    path:"/abouts",
    children: [
        {title: "公告事项", path: "/abouts/notice"},
        {title: "常见问题", path: "/abouts/common-problem"},
        {title: "答疑解惑", path: "/abouts/answering-question"},
        {title: "资料室", path: "/abouts/material-room"},
    ]
}

export const APP_MENUS_PERSONAL_CENTER_MENUS = {
    title: "个人中心",
    path:"/personal-center",
    children: [
        {title: "我的简历", path: "/personal-center/resume"},
        {title: "听课申请现况", path: "/personal-center/course-application"},
        {title: "我的学习现况", path: "/personal-center/my-studies"},
        {title: "我的提问", path: "/personal-center/my-question"},
        {title: "证书颁发", path: "/personal-center/certificate-issuance"},
        {title: "个人信息管理", path: "/personal-center/personal-info"},
    ]
}

/**
 * @description 商学院介绍的固定路由
 * @type {string}
 */
export const APP_CATEGORY_MENUS_BASE_PATH = "/college-introductions/college-introduction"


/**
 * @description 课程的固定路由
 * @type {string}
 */
export const APP_CURRICULUM_MENUS_BASE_PATH = "/curriculums/curriculum"
export const APP_CURRICULUM_MENUS_BASE_PATH_SUFFIX = "/curriculums"
